import type { CohortFinding } from '@/lib/types';

interface FindingsListProps {
  findings: CohortFinding[];
}

export function FindingsList({ findings }: FindingsListProps) {
  // Bar width is normalized: highest count = 100%
  const max = Math.max(...findings.map((f) => f.count));

  return (
    <div className="glass-panel py-1">
      {findings.map((f) => (
        <div
          key={f.name}
          className="grid grid-cols-[1fr_80px_60px] gap-3.5 items-center px-5 py-3 border-b border-line last:border-b-0 max-[760px]:grid-cols-[1fr_50px] max-[760px]:gap-2.5 max-[760px]:px-4 max-[760px]:py-2.5"
        >
          <div>
            <div className="text-sm font-medium">{f.name}</div>
            <div className="text-xs text-tertiary mt-px">{f.description}</div>
          </div>
          <div className="h-1 bg-subtle rounded-sm overflow-hidden max-[760px]:hidden">
            <div
              className="h-full bg-secondary"
              style={{ width: `${(f.count / max) * 100}%` }}
            />
          </div>
          <div>
            <div className="text-right text-sm font-bold tnum tracking-[-0.01em]">
              {f.count}
            </div>
            <div className="text-[11px] text-tertiary font-medium text-right">{f.pct}%</div>
          </div>
        </div>
      ))}
    </div>
  );
}
